import angular from 'angular';

import TankPanelService from './TankPanelService';
import tankImageComponent from './tankImageComponent';
import TankPanelComponent from './TankPanelComponent';
import tankStatusComponent from './tankStatusComponent';
import tankTableComponent from './tankTableComponent';

export default angular
  .module('petroCloud.dashboard.tankPanel', [
    'ui.bootstrap',
    'angular-growl',
    'ngSails'
  ])
  .service('TankPanelService', TankPanelService)
  .component(tankImageComponent.name, tankImageComponent)
  .component(TankPanelComponent.name, TankPanelComponent)
  .component(tankStatusComponent.name, tankStatusComponent)
  .component(tankTableComponent.name, tankTableComponent)
  .name;
